(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasGSAP = typeof window.gsap !== "undefined";
  if (hasGSAP && window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

  /* ---------- smooth scroll ---------- */
  if (!reduce && typeof window.Lenis !== "undefined"){
    var lenis = new Lenis({ duration:1.15, smoothWheel:true });
    window.calmaLenis = lenis;   /* Warenkorb-Schublade haelt das Scrollen an */
    if (hasGSAP){
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      requestAnimationFrame(function raf(t){ lenis.raf(t); requestAnimationFrame(raf); });
    }
    /* Shopify: Anker koennen als "#formel" oder "/#formel" kommen - beide
       gleiten, solange sie auf die aktuelle Seite zeigen. */
    document.querySelectorAll('a[href*="#"]').forEach(function(a){
      if (!a.hash || a.hash === "#" || a.pathname !== location.pathname) return;
      a.addEventListener("click", function(e){
        var el = null;
        try { el = document.querySelector(a.hash); } catch(err){ el = null; }
        if (el){ e.preventDefault(); lenis.scrollTo(el, { offset:-70 }); }
      });
    });
  }

  /* ---------- split headlines into words ---------- */
  function split(el){
    var parts = el.innerHTML.split(/(<em>.*?<\/em>|\s+)/g).filter(function(s){ return s && s.trim(); });
    el.innerHTML = parts.map(function(p){
      return '<span class="word"><i>' + p + '</i></span>';
    }).join(" ");
    return el.querySelectorAll(".word i");
  }

  if (hasGSAP && !reduce){
    document.querySelectorAll("[data-split]").forEach(function(h){
      var words = split(h);
      gsap.from(words, {
        yPercent:115, duration:1.05, ease:"expo.out", stagger:0.045,
        scrollTrigger:{ trigger:h, start:"top 88%" }
      });
    });

    /* generic reveals */
    gsap.utils.toArray("[data-reveal]").forEach(function(el, i){
      gsap.from(el, {
        y:32, autoAlpha:0, duration:.9, ease:"power3.out", delay:(i%4)*.06,
        scrollTrigger:{ trigger:el, start:"top 90%" }
      });
    });

    /* hero pouch float + parallax */
    var pouch = document.getElementById("hero-pouch");
    if (pouch) gsap.to(pouch, { y:-18, duration:3.6, ease:"sine.inOut", yoyo:true, repeat:-1 });
    if (pouch) gsap.to(pouch, {
      yPercent:14, scale:.94, ease:"none",
      scrollTrigger:{ trigger:".hero", start:"top top", end:"bottom top", scrub:.6 }
    });
    gsap.to(".halo", {
      scale:1.12, ease:"none",
      scrollTrigger:{ trigger:".hero", start:"top top", end:"bottom top", scrub:1 }
    });

    /* ticker */
    var track = document.getElementById("tick");
    if (track){
      track.innerHTML += track.innerHTML;
      gsap.to(track, { xPercent:-50, duration:26, ease:"none", repeat:-1 });
    }

    /* curve drawing */
    var curve = document.getElementById("curve");
    if (curve){
    var len = curve.getTotalLength();
    gsap.set(curve, { strokeDasharray:len, strokeDashoffset:len });
    gsap.set("#curve-fill", { autoAlpha:0 });
    gsap.set("[data-mark]", { autoAlpha:0, y:10 });
    gsap.set(".curve-key", { autoAlpha:0 });
    /* Die Vergleichslinie ist gestrichelt - ihr dasharray traegt das Muster,
       also blenden wir sie ein statt sie zu zeichnen. */
    gsap.set("#curve-ohne", { autoAlpha:0 });
    var tl = gsap.timeline({
      scrollTrigger:{ trigger:".curve-box", start:"top 78%", end:"bottom 62%", scrub:.7 }
    });
    tl.to("#curve-ohne", { autoAlpha:1, duration:1 }, 0)
      .to(curve, { strokeDashoffset:0, ease:"none", duration:3 }, .3)
      .to(".curve-key", { autoAlpha:1, duration:.8 }, .6)
      .to("#curve-fill", { autoAlpha:1, duration:1 }, 1.5)
      .to("[data-mark]", { autoAlpha:1, y:0, stagger:.5, duration:.7 }, 1.3);
    }

    /* ritual: die vier Felder kommen nacheinander herein */
    var ritual = document.querySelector(".ritual");
    if (ritual){
      var rtl = gsap.timeline({
        scrollTrigger:{ trigger:ritual, start:"top 82%", once:true }
      });
      rtl.from(ritual.querySelectorAll(".rit"), {
        autoAlpha:0, y:26, duration:.75, ease:"power3.out", stagger:.13
      });
      var ritMedia = ritual.querySelectorAll(".rit-media");
      if (ritMedia.length) rtl.from(ritMedia, {
        autoAlpha:0, scale:.96, duration:.6, ease:"power2.out", stagger:.11
      }, .2);
    }
  }

  /* ---------- angebotsband ---------- */
  (function(){
    var box = document.getElementById("announce");
    if (!box) return;
    var items = [].slice.call(box.querySelectorAll(".announce-i"));
    if (items.length < 2 || reduce) return;          /* bei reduced motion bleibt das erste stehen */
    var i = 0, timer = null;
    function step(){
      items[i].classList.remove("is-on");
      i = (i + 1) % items.length;
      items[i].classList.add("is-on");
    }
    function start(){ if (!timer) timer = setInterval(step, 4200); }
    function stop(){ clearInterval(timer); timer = null; }
    start();
    box.addEventListener("mouseenter", stop);
    box.addEventListener("mouseleave", start);
    document.addEventListener("visibilitychange", function(){
      if (document.hidden) stop(); else start();
    });
  })();

  /* ---------- vorher / nachher ---------- */
  (function(){
    var box = document.getElementById("ba"), rng = document.getElementById("ba-range");
    if (!box || !rng) return;
    function apply(){ box.style.setProperty("--x", rng.value + "%"); }
    rng.addEventListener("input", apply);
    apply();
    /* Ziehen mit Maus und Finger: der Regler deckt die Flaeche ab, wir
       uebersetzen nur die Position in einen Wert. */
    function fromPointer(e){
      var r = box.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      rng.value = Math.max(0, Math.min(100, x));
      apply();
    }
    box.addEventListener("pointerdown", function(e){
      box.setPointerCapture(e.pointerId); fromPointer(e);
    });
    box.addEventListener("pointermove", function(e){
      if (e.buttons) fromPointer(e);
    });
  })();

  /* ---------- evening clock ---------- */
  var ct = document.getElementById("clock-t"), cl = document.getElementById("clock-l");
  if (ct && cl) {
  var labels = [[0,"Feierabend"],[.28,"Runterfahren"],[.5,"Calma"],[.7,"Bildschirm aus"],[.86,"Licht aus"]];
  var maxScroll = 0, queued = false;
  function measure(){ maxScroll = document.documentElement.scrollHeight - window.innerHeight; }
  function tick(){
    queued = false;
    var h = maxScroll;
    var p = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
    var mins = 20*60 + 30 + p*180;               // 20:30 → 23:30
    var hh = Math.floor(mins/60) % 24, mm = Math.floor(mins%60);
    ct.textContent = String(hh).padStart(2,"0") + ":" + String(mm).padStart(2,"0");
    var lab = labels[0][1];
    for (var i=0;i<labels.length;i++) if (p >= labels[i][0]) lab = labels[i][1];
    cl.textContent = lab;
  }
  window.addEventListener("scroll", function(){ if (!queued){ queued = true; requestAnimationFrame(tick); } }, { passive:true });
  window.addEventListener("resize", function(){ measure(); tick(); });
  window.addEventListener("load", function(){ measure(); tick(); });
  if ("ResizeObserver" in window) new ResizeObserver(measure).observe(document.body);
  measure(); tick();
  }

  /* ---------- flavour rail ---------- */
  var rail = document.getElementById("rail");
  if (rail) rail.querySelectorAll(".flav").forEach(function(b){
    function pick(){
      var img = b.getAttribute("data-img");
      var hp = document.getElementById("hero-pouch"), bp = document.getElementById("buy-pouch");
      if (hp){ hp.src = img; hp.alt = "Calma " + b.querySelector(".flav-name").textContent; }
      if (bp) bp.src = img;
    }
    b.addEventListener("click", pick);
    b.addEventListener("mouseenter", pick);
  });

  /* ---------- portion breakdown ---------- */
  var keys = [].slice.call(document.querySelectorAll(".key"));
  var segs = [].slice.call(document.querySelectorAll(".seg"));
  var panels = [].slice.call(document.querySelectorAll(".panel"));

  function countUp(panel){
    if (!panel) return;
    var el = panel.querySelector(".big[data-count]");
    if (!el) return;
    var unit = el.querySelector(".unit").outerHTML, target = +el.dataset.count;
    if (!hasGSAP || reduce){ el.innerHTML = target + unit; return; }
    var o = { v:0 };
    gsap.to(o, { v:target, duration:1, ease:"power2.out", onUpdate:function(){
      el.innerHTML = Math.round(o.v) + unit;
    }});
  }
  function select(k, count){
    keys.forEach(function(b){
      var on = +b.dataset.k === k;
      b.dataset.on = on ? "1" : "0";
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
    segs.forEach(function(s){ s.dataset.on = (+s.dataset.k === k) ? "1" : "0"; });
    panels.forEach(function(p,i){ p.hidden = (i !== k); });
    if (count !== false) countUp(panels[k]);
  }
  keys.concat(segs).forEach(function(b){
    b.addEventListener("click", function(){ select(+b.dataset.k); });
  });
  keys.forEach(function(b,i){
    b.addEventListener("keydown", function(e){
      var d = (e.key==="ArrowRight"||e.key==="ArrowDown") ? 1
            : (e.key==="ArrowLeft"||e.key==="ArrowUp") ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = (i + d + keys.length) % keys.length;
      keys[n].focus(); select(+keys[n].dataset.k);
    });
  });
  if (hasGSAP && !reduce){
    if (document.getElementById("bar")) gsap.from("#bar .seg", {
      width:0, duration:1.1, ease:"power3.out", stagger:.09, clearProps:"width",
      scrollTrigger:{ trigger:"#bar", start:"top 86%", once:true }
    });
    if (document.getElementById("bar")) ScrollTrigger.create({ trigger:"#bar", start:"top 86%", once:true,
      onEnter:function(){ countUp(panels[0]); } });
  }

  /* ---------- product gallery ---------- */
  (function(){
    var shot = document.getElementById("shot"), img = document.getElementById("shot-img");
    var thumbs = [].slice.call(document.querySelectorAll(".thumb"));
    if (!shot || !img || !thumbs.length) return;
    var hasFade = typeof gsap !== "undefined" && !reduce, token = 0;
    function opaque(){ if (hasFade) gsap.killTweensOf(img); img.style.opacity = ""; img.style.visibility = ""; }
    /* grosses Bild schon beim Ueberfahren laden, dann wechselt es ohne Wartezeit */
    function preload(b){
      if (b.dataset.mode === "video" || b._pre) return;
      b._pre = new Image(); if (b.dataset.srcset){ b._pre.sizes = img.sizes; b._pre.srcset = b.dataset.srcset; } b._pre.src = b.dataset.src;
    }
    thumbs.forEach(function(b){
      b.addEventListener("pointerenter", function(){ preload(b); });
      b.addEventListener("focus", function(){ preload(b); });
      b.addEventListener("click", function(){
        var my = ++token;
        thumbs.forEach(function(o){ o.setAttribute("aria-pressed", o === b ? "true" : "false"); });
        var vid = shot.querySelector("video.shot-vid");
        if (b.dataset.mode === "video"){
          if (!vid){
            vid = document.createElement("video");
            vid.className = "shot-vid"; vid.muted = true; vid.loop = true;
            vid.playsInline = true; vid.setAttribute("playsinline", "");
            shot.appendChild(vid);
          }
          shot.style.setProperty("--fl", "transparent");
          shot.classList.add("is-photo");
          vid.poster = b.dataset.poster || "";
          if (vid.getAttribute("src") !== b.dataset.src) vid.src = b.dataset.src;
          opaque(); img.hidden = true; vid.hidden = false;
          if (!reduce){ var pr = vid.play(); if (pr && pr.catch) pr.catch(function(){}); }
          return;
        }
        if (vid){ vid.pause(); vid.hidden = true; }
        img.hidden = false;
        /* Einblenden immer bis ganz sichtbar, laufende Blende vorher abbrechen.
           Frueher gsap.from(): bei schnellem Klicken wurde die halb transparente
           Zwischenstufe zum Endwert und das Bild blieb unsichtbar haengen. */
        opaque();
        if (hasFade && img.getAttribute("src") !== b.dataset.src) gsap.set(img, { autoAlpha:0 });
        img.srcset = b.dataset.srcset || "";
        img.src = b.dataset.src;
        var reveal = function(){
          if (my !== token) return;                     /* inzwischen anderes Bild gewaehlt */
          if (hasFade) gsap.to(img, { autoAlpha:1, duration:.3, overwrite:true });
          else opaque();
        };
        if (img.decode) img.decode().then(reveal, reveal); else if (img.complete) reveal(); else img.onload = img.onerror = reveal;
        shot.classList.toggle("is-photo", b.dataset.mode !== "pouch");
        if (b.dataset.mode === "pouch"){
          shot.style.setProperty("--fl", b.dataset.fl);
          img.style.height = "88%"; img.style.width = "auto";
          img.style.objectFit = "contain";
        } else {
          shot.style.setProperty("--fl", "transparent");
          img.style.height = "100%"; img.style.width = "100%";
          img.style.objectFit = "cover";
        }
      });
    });
  })();

  /* ---------- price + abo ---------- */
  (function(){
    var ABO_RABATT = 0.15;                 /* eine Quelle der Wahrheit */

    function eur(v){ return v.toFixed(2).replace(".", ",") + " €"; }
    function q(id){ return document.getElementById(id); }

    /* Shopify: die Mengen-Radios sind die echten Varianten (name="id").
       Abo-Preise kommen aus dem Selling Plan, wenn einer hinterlegt ist. */
    function aboPreis(r, basis){
      var p = parseFloat(r.dataset.priceAbo);
      return isFinite(p) ? p : basis * (1 - ABO_RABATT);
    }

    function render(){
      var mengen = [].slice.call(document.querySelectorAll('input[data-menge]'));
      var abo    = !!document.querySelector('input[name="modus"][value="abo"]:checked');
      if (!mengen.length) return;

      mengen.forEach(function(r){
        var lab = r.closest(".opt");
        if (!lab) return;
        var basis  = parseFloat(r.dataset.price);
        var abende = parseInt(r.dataset.abende, 10);
        var op = lab.querySelector(".op"), os = lab.querySelector(".os"),
            alt = lab.querySelector(".oalt");
        if (!isFinite(basis)){
          if (op) op.textContent = "[PREIS]";
          if (os) os.textContent = "noch nicht festgelegt";
          if (alt) alt.hidden = true;
          return;
        }
        var preis = abo ? aboPreis(r, basis) : basis;
        if (op) op.textContent = eur(preis);
        if (alt){ alt.textContent = eur(basis); alt.hidden = !abo; }
        if (os) os.textContent = abende ? eur(preis / abende) + " / Abend" : "";
      });

      var sel = mengen.filter(function(r){ return r.checked; })[0];
      if (!sel) sel = mengen[0];
      var basis  = parseFloat(sel.dataset.price);
      var abende = parseInt(sel.dataset.abende, 10);
      var preis  = isFinite(basis) ? (abo ? aboPreis(sel, basis) : basis) : NaN;

      var plan = document.getElementById("selling-plan");
      if (plan) plan.value = (abo && sel.dataset.plan) ? sel.dataset.plan : "";
      var buy = document.getElementById("buy-submit");
      if (buy) buy.disabled = sel.disabled;

      var total = q("total"), per = q("per"), save = q("abo-save"), note = q("abo-note"),
          alt = q("total-alt"),
          bt = q("buybar-total"), bp = q("buybar-per");
      if (bt) bt.textContent = isFinite(preis) ? eur(preis) : "[PREIS]";
      if (bp) bp.textContent = (isFinite(preis) && abende)
        ? eur(preis / abende) + " pro Abend" : "Preis folgt";
      if (total) total.textContent = isFinite(preis) ? eur(preis) : "[PREIS]";
      if (alt){ alt.textContent = isFinite(basis) ? eur(basis) : ""; alt.hidden = !(abo && isFinite(basis)); }
      if (per) per.textContent = (isFinite(preis) && abende)
        ? eur(preis / abende) + " pro Abend" : "Preis steht noch aus";
      if (save){
        save.hidden = !(abo && isFinite(basis));
        if (!save.hidden) save.textContent = "Du sparst " + eur(basis - preis) + " pro Lieferung";
      }
      if (note) note.hidden = !abo;
    }

    /* Delegation am Dokument: greift unabhaengig davon, wann die Felder in
       den DOM kommen, und ueberlebt jeden Austausch der Kaufbox. */
    function onAny(e){
      var t = e.target;
      if (t && ((t.hasAttribute && t.hasAttribute("data-menge")) || t.name === "modus")) render();
    }
    document.addEventListener("change", onAny);
    document.addEventListener("input", onAny);
    document.addEventListener("click", function(e){
      if (e.target && e.target.closest && e.target.closest(".opts")) setTimeout(render, 0);
    });
    render();

    /* Kaufleiste: von Anfang an sichtbar, ausgeblendet nur solange der echte
       Warenkorb-Button im Bild ist (Mobil: Kaufen ohne Scrollen erreichbar) */
    var bar = document.getElementById("buybar"), buy = document.getElementById("buy-submit");
    if (bar && buy && "IntersectionObserver" in window){
      new IntersectionObserver(function(e){
        bar.classList.toggle("on", !e[0].isIntersecting);
      }, { threshold:0 }).observe(buy);
    } else if (bar) bar.classList.add("on");
  })();

  /* ---------- magnetic buttons + cursor ---------- */
  var fine = window.matchMedia("(pointer:fine)").matches && window.innerWidth > 900;
  if (fine && !reduce && document.getElementById("cur")){
    var cur = document.getElementById("cur"), cx=0, cy=0, tx=0, ty=0;
    window.addEventListener("mousemove", function(e){ tx=e.clientX; ty=e.clientY; });
    (function loop(){
      cx += (tx-cx)*.18; cy += (ty-cy)*.18;
      cur.style.transform = "translate(" + cx + "px," + cy + "px)";
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll("a,button,summary,label").forEach(function(el){
      el.addEventListener("mouseenter", function(){ cur.classList.add("on"); });
      el.addEventListener("mouseleave", function(){ cur.classList.remove("on"); });
    });
    document.querySelectorAll("[data-magnet]").forEach(function(el){
      el.addEventListener("mousemove", function(e){
        var r = el.getBoundingClientRect();
        el.style.transform = "translate(" + (e.clientX - r.left - r.width/2)*.28 + "px," +
                                            (e.clientY - r.top - r.height/2)*.4 + "px)";
      });
      el.addEventListener("mouseleave", function(){ el.style.transform = ""; });
    });
  }

  /* ---------- film grain ---------- */
  (function(){
    var c = document.getElementById("grain");
    if (!c) return;
    var x = c.getContext("2d"), n = 128;
    c.width = n; c.height = n;
    function draw(){
      var d = x.createImageData(n, n), a = d.data;
      for (var i=0;i<a.length;i+=4){
        var v = Math.random()*255;
        a[i]=a[i+1]=a[i+2]=v; a[i+3]=255;
      }
      x.putImageData(d, 0, 0);
    }
    /* einmal zeichnen: neu verrauschen hiesse, den ganzen Bildschirm laufend neu zu malen */
    draw();
  })();

  /* ---------- night sky in hero (WebGL, canvas fallback) ---------- */
  (function(){
    var canvas = document.getElementById("sky");
    var hero = document.querySelector(".hero");
    if (!canvas || !hero) return;
    if (getComputedStyle(canvas).display === "none") return;   /* Video-Hero blendet den Himmel aus */

    function hex(name, fb){
      var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fb;
      var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(v);
      if (!m) return [0,0,0];
      return [parseInt(m[1],16)/255, parseInt(m[2],16)/255, parseInt(m[3],16)/255];
    }

    /* --- 2D fallback: the same light, painted once --- */
    function fallback(){
      var x = canvas.getContext("2d");
      if (!x) return;
      function draw(){
        var r = canvas.getBoundingClientRect();
        canvas.width = r.width; canvas.height = r.height;
        var g = x.createRadialGradient(r.width*0.5, r.height*0.2, 0, r.width*0.5, r.height*0.2, r.width*0.75);
        g.addColorStop(0, "rgba(229,186,70,.20)");
        g.addColorStop(0.45, "rgba(27,58,107,.18)");
        g.addColorStop(1, "rgba(0,0,0,0)");
        x.clearRect(0,0,r.width,r.height);
        x.fillStyle = g; x.fillRect(0,0,r.width,r.height);
      }
      draw();
      window.addEventListener("resize", draw);
    }

    var gl = null;
    try {
      gl = canvas.getContext("webgl", { alpha:false, antialias:false, depth:false, powerPreference:"low-power" })
        || canvas.getContext("experimental-webgl", { alpha:false, antialias:false, depth:false });
    } catch(e){ gl = null; }
    if (!gl){ fallback(); return; }

    var VS = [
      "attribute vec2 a;",
      "void main(){ gl_Position = vec4(a, 0.0, 1.0); }"
    ].join("\n");

    var FS = [
      "precision highp float;",
      "uniform vec2 u_res;",
      "uniform float u_time;",
      "uniform vec3 u_bg;",
      "uniform vec3 u_gold;",

      "float hash21(vec2 p){",
      "  p = fract(p * vec2(123.34, 456.21));",
      "  p += dot(p, p + 45.32);",
      "  return fract(p.x * p.y);",
      "}",
      "float noise(vec2 p){",
      "  vec2 i = floor(p), f = fract(p);",
      "  f = f * f * (3.0 - 2.0 * f);",
      "  float a = hash21(i);",
      "  float b = hash21(i + vec2(1.0, 0.0));",
      "  float c = hash21(i + vec2(0.0, 1.0));",
      "  float d = hash21(i + vec2(1.0, 1.0));",
      "  return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);",
      "}",
      "float fbm(vec2 p){",
      "  float v = 0.0, a = 0.5;",
      "  for (int i = 0; i < 5; i++){ v += a * noise(p); p *= 2.02; a *= 0.5; }",
      "  return v;",
      "}",
      "void main(){",
      "  vec2 uv = gl_FragCoord.xy / u_res;",
      "  float ar = u_res.x / u_res.y;",
      "  float t = u_time;",
      /* one warm light source behind the scene, drifting and breathing */
      "  vec2 c = vec2(0.5 + 0.045 * sin(t * 0.07), 0.80 + 0.03 * sin(t * 0.05 + 1.3));",
      "  vec2 d = (uv - c) * vec2(ar, 1.0);",
      "  float g = exp(-2.6 * dot(d, d));",
      "  float breathe = 0.86 + 0.14 * sin(t * 0.16);",
      /* wide cool fill so the corners do not fall flat */
      "  vec2 e = (uv - vec2(0.5, 0.55)) * vec2(ar, 1.0);",
      "  float f = exp(-0.9 * dot(e, e));",
      /* slow scrim - keeps a large dark field from reading as a flat banner */
      "  float scrim = fbm(vec2(uv.x * ar * 1.4, uv.y * 1.4 - t * 0.012));",
      "  vec3 col = u_bg;",
      "  col += vec3(0.045, 0.085, 0.17) * f * 0.55;",
      "  col += u_gold * g * 0.30 * breathe;",
      "  col += vec3(0.030, 0.055, 0.110) * (scrim - 0.5) * 0.35;",
      "  col *= 1.0 - 0.30 * pow(clamp(length(uv - 0.5) * 1.2, 0.0, 1.0), 2.2);",
      /* dither, or a dark gradient bands on 8-bit displays */
      "  col += (hash21(gl_FragCoord.xy) - 0.5) / 255.0;",
      "  gl_FragColor = vec4(col, 1.0);",
      "}"
    ].join("\n");

    function compile(type, src){
      var sh = gl.createShader(type);
      gl.shaderSource(sh, src); gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) return null;
      return sh;
    }
    var vs = compile(gl.VERTEX_SHADER, VS), fs = compile(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs){ fallback(); return; }
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)){ fallback(); return; }
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, "a");
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uRes = gl.getUniformLocation(prog, "u_res"),
        uTime = gl.getUniformLocation(prog, "u_time"),
        uBg = gl.getUniformLocation(prog, "u_bg"),
        uGold = gl.getUniformLocation(prog, "u_gold");

    function colors(){
      var bg = hex("--bg-b", "#061427"), gold = hex("--gold-lt", "#E5BA46");
      gl.uniform3f(uBg, bg[0], bg[1], bg[2]);
      gl.uniform3f(uGold, gold[0], gold[1], gold[2]);
    }
    function size(){
      var r = canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      var w = Math.max(1, Math.round(r.width * dpr)), hh = Math.max(1, Math.round(r.height * dpr));
      if (canvas.width !== w || canvas.height !== hh){
        canvas.width = w; canvas.height = hh;
        gl.viewport(0, 0, w, hh);
        gl.uniform2f(uRes, w, hh);
      }
    }
    var t0 = performance.now(), raf = 0, visible = true;
    function draw(now){
      raf = 0;
      size();
      gl.uniform1f(uTime, (now - t0) / 1000);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      if (!reduce && visible) raf = requestAnimationFrame(draw);
    }
    colors(); size();
    draw(performance.now());

    window.addEventListener("resize", function(){ if (!raf) raf = requestAnimationFrame(draw); });
    if (window.matchMedia) {
      var mq = window.matchMedia("(prefers-color-scheme: dark)");
      (mq.addEventListener ? mq.addEventListener.bind(mq, "change") : mq.addListener.bind(mq))(function(){
        colors(); if (!raf) raf = requestAnimationFrame(draw);
      });
    }
    /* stop drawing once the hero has scrolled away */
    if ("IntersectionObserver" in window){
      new IntersectionObserver(function(e){
        visible = e[0].isIntersecting;
        if (visible && !reduce && !raf) raf = requestAnimationFrame(draw);
      }, { threshold:0 }).observe(hero);
    }
    canvas.addEventListener("webglcontextlost", function(e){ e.preventDefault(); visible = false; });
  })();
})();

/* ---------- Direktvergleich: Balken beim Einscrollen fuellen ---------- */
(function(){
  var vs = document.querySelector("[data-vs]");
  if (!vs) return;
  if (!("IntersectionObserver" in window)){ vs.classList.add("on"); return; }
  new IntersectionObserver(function(entries, obs){
    if (entries[0].isIntersecting){ vs.classList.add("on"); obs.disconnect(); }
  }, { threshold:.18 }).observe(vs);
})();

/* ---------- Inhalts-Videos: nur abspielen, wenn sichtbar; bei reduzierter Bewegung stehen lassen ---------- */
(function(){
  var vids = document.querySelectorAll("video.shot");
  if (!vids.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    vids.forEach(function(v){ v.removeAttribute("autoplay"); v.pause(); v.controls = true; });
    return;
  }
  if (!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ var p = e.target.play(); if (p && p.catch) p.catch(function(){}); }
      else e.target.pause();
    });
  }, { threshold:.2 });
  vids.forEach(function(v){ io.observe(v); });
})();

/* ---------- Hero-Video: bei reduzierter Bewegung angehalten auf dem Posterbild ---------- */
(function(){
  var v=document.getElementById("hero-video"); if(!v) return;
  var mq=window.matchMedia("(prefers-reduced-motion: reduce)");
  function apply(){ if(mq.matches){ v.pause(); v.removeAttribute("autoplay"); } else { var p=v.play(); if(p&&p.catch) p.catch(function(){}); } }
  apply(); if(mq.addEventListener) mq.addEventListener("change",apply);
})();

/* ---------- Hero-Video: passende Datei je Bildschirm laden (media auf <source> kann nicht jeder Browser) ---------- */
(function(){
  var hv=document.getElementById("hero-video"); if(!hv || !hv.dataset.desktop) return;
  var mq=window.matchMedia("(max-width: 920px)");
  var still=window.matchMedia("(prefers-reduced-motion: reduce)");
  function base(u){ return (u||"").split("?")[0].replace(/^https?:/,""); }
  function pick(){
    var want=mq.matches ? hv.dataset.mobile : hv.dataset.desktop;
    if(base(hv.currentSrc || hv.src)===base(want)) return;
    hv.src=want; hv.load();
    if(!still.matches){ var p=hv.play(); if(p&&p.catch) p.catch(function(){}); }
  }
  pick(); if(mq.addEventListener) mq.addEventListener("change",pick);
})();

/* ---------- Theme-Editor: nach dem Neuladen einer Section die Scroll-Trigger neu vermessen ---------- */
(function(){
  if (!window.Shopify || !Shopify.designMode) return;
  function refresh(){ if (window.ScrollTrigger) ScrollTrigger.refresh(); }
  ["shopify:section:load","shopify:section:unload","shopify:section:reorder"].forEach(function(ev){
    document.addEventListener(ev, refresh);
  });
})();
